
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-brain",
      function () {
        return require("private-next-pages/company-brain.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-brain"])
      });
    }
  